<template lang="pug">
	main(@keyup.esc="handleCloseSearch()")#app
		Header(ref="header" @loaded="headerLoaded = true") 
		article#page
			router-view
			Footer(v-if="headerLoaded")
		AsideLinhaDoTempo(v-if="headerLoaded")
		AsideAcessoRapido(v-if="headerLoaded")
		AsideImage(v-if="headerLoaded")
		Cookies
		<portal-target id="portal-modal" name="modals"></portal-target>
</template>

<script>
import AsideAcessoRapido from "@components/AsideAcessoRapido/AsideAcessoRapido";
import AsideLinhaDoTempo from "@components/AsideLinhaDoTempo/AsideLinhaDoTempo";
import AsideImage from '@components/AsideImage/AsideImage'
import Footer from "@components/Footer/Footer";
import Header from "@components/Header/Header";
import Cookies from "@sections/Pagina/Cookies/Cookies";

export default {
	name: 'template-app',
	metaInfo() {
		return {
			titleTemplate: (title) => title ? `${title} - Coamo Agroindustrial Cooperativa` : 'Coamo Agroindustrial Cooperativa',
			meta: [
				{ name: 'description', content: '' },
			],
		}
	},
	data() {
		return {
			headerLoaded: false,
		};
	},
	components: {
		Header,
		Footer,
		AsideLinhaDoTempo,
		AsideAcessoRapido,
		AsideImage,
		Cookies,
	},
	methods: {
		handleCloseSearch() {
			this.$store.commit('search/setDisplay', false)
		},
		loadLibrasLibrary() {
			const script = document.createElement("script");
			script.src = "https://vlibras.gov.br/app/vlibras-plugin.js";
			script.async = true;
			document.head.appendChild(script);
		}
	},
	mounted() {
		setTimeout(() => {
			this.loadLibrasLibrary()
		}, 3000)
	}
}
</script>

<style lang="stylus" scoped src="./App.styl"></style>
